import { render, staticRenderFns } from "./SuppliersPage.vue?vue&type=template&id=411ee0de"
import script from "./SuppliersPage.vue?vue&type=script&lang=js"
export * from "./SuppliersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports